const r = {
  form: "var(--plac-background-form)",
  white: "var(--plac-primary-white)"
};
export {
  r as MAP_BACKGROUND_OPTIONS
};
//# sourceMappingURL=index.es684.js.map
